import React from "react";
import { newReportConfig } from "../mdmReportsUtils";
import CompactCheckboxDropdown from "../components/CompactCheckboxDropdown";
import "./DistributorFilter.css";

interface DistributorFilterProps {
  selectedReport: newReportConfig;
  filters: Record<string, string[]>;
  optionsMap: Record<string, { label: string; value: string }[]>;
  loadingMap: Record<string, boolean>;
  onFilterChange: (key: string, value: string | null) => void;
  onMultiFilterChange?: (key: string, values: string[]) => void;
  onLoadOptions: (fieldKey: string) => void;
  disabled?: boolean;
  disabledReason?: string;
  dropdownWidth?: number | string;
  searchText?: string;
  onSearchChange?: (value: string) => void;
  enableSelectAll?: boolean;
  selectAllLabel?: string;
}

const DistributorFilter: React.FC<DistributorFilterProps> = ({
  selectedReport,
  filters,
  optionsMap,
  loadingMap,
  onFilterChange,
  onMultiFilterChange,
  onLoadOptions,
  disabled = false,
  disabledReason,
  dropdownWidth,
  searchText,
  onSearchChange,
  enableSelectAll = false,
  selectAllLabel
}) => {
  if (!selectedReport?.distributorFilter?.enabled || !selectedReport.distributorFilter) {
    return null;
  }

  const fieldKey = selectedReport.distributorFilter.field;
  const options = optionsMap[fieldKey] || [];
  const selectedValues = filters[fieldKey] || [];

  const handleChange = (values: string[]) => {
    if (onMultiFilterChange) {
      onMultiFilterChange(fieldKey, values);
    }
  };

  const handleOpen = () => {
    // Load distributor options if not already loaded
    if (!disabled && (!options || options.length === 0)) {
      onLoadOptions(fieldKey);
    }
  };

  const handleClose = () => {
    // Clear search text when dropdown closes
    if (onSearchChange) {
      onSearchChange("");
    }
  };

  return (
    <div className="distributor-filter-wrapper">
      <CompactCheckboxDropdown
        label={
          selectedReport.distributorFilter.label
        }
        options={options}
        selectedValues={selectedValues}
        onChange={handleChange}
        onOpen={handleOpen}
        loading={loadingMap[fieldKey] || false}
        disabled={disabled}
        placeholder="Distributor"
        width={dropdownWidth}
        dropdownWidth={250}
        searchText={searchText}
        onSearchChange={onSearchChange}
        enableSelectAll={enableSelectAll}
        selectAllLabel={selectAllLabel}
        onClose={handleClose}
      />
    </div>
  );
};

export default DistributorFilter;

